export enum Countries {
  CZECHIA = 'CZ',
  SLOVAKIA = 'SK',
  HUNGARY = 'HU',
  LITHUANIA = 'LT',
  LATVIA = 'LV',
  ESTONIA = 'EE',
}
